import React from 'react';
import styled from 'styled-components';
import { Banner } from '../Banner/Banner';
import { Box } from '../Box/Box';
import { Button } from '../Button/Button';
import { Flex } from '../Flex/Flex';
import { Link } from '../Link/Link';
import { Relative } from '../Relative/Relative';
import { colorSchemeCustomForeground } from '../utils/utils';
const BannerWithRadius = /*#__PURE__*/styled(Banner).withConfig({
  displayName: "GenericBanner__BannerWithRadius",
  componentId: "sc-1ae3a6t-0"
})(["cursor:", ";", ""], props => props.onClick ? 'pointer' : 'cursor', colorSchemeCustomForeground);
const WrapperLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "GenericBanner__WrapperLink",
  componentId: "sc-1ae3a6t-1"
})(["z-index:1;display:block;position:absolute;top:0;left:0;right:0;bottom:0;"]);
const CustomLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "GenericBanner__CustomLink",
  componentId: "sc-1ae3a6t-2"
})(["display:inline-flex;z-index:2;"]);
const CustomButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "GenericBanner__CustomButton",
  componentId: "sc-1ae3a6t-3"
})(["z-index:2;text-decoration:", ";"], props => props.buttonTextUnderline ? 'underline' : 'none');
/**
 * @public
 */
export function GenericBanner({
  alignItems = 'center',
  borderRadius = '6px',
  buttonClick,
  buttonSize,
  buttonVariation = 'link',
  ctaText,
  fontSize = [0, null, null, 1],
  heading,
  iconLeft,
  iconRight,
  imageLeft,
  justifyContent = 'center',
  linkVariation = 'link',
  linkColor = 'primary',
  text,
  /* eslint-disable @typescript-eslint/naming-convention */
  URLProps,
  ...props
}) {
  function onClick(e) {
    e.stopPropagation();
    buttonClick();
  }
  return React.createElement(Relative, null, URLProps && React.createElement(WrapperLink, {
    tabIndex: -1,
    "aria-hidden": 'true',
    ...URLProps
  }), React.createElement(BannerWithRadius, {
    ...props,
    onClick: URLProps ? null : buttonClick,
    iconUsesColorScheme: true,
    // we need to unset Banner's color prop if colorScheme is provided so it doesn't render its own icon
    color: !props.colorScheme ? props.color : null,
    borderRadius: borderRadius
  }, React.createElement(Flex, {
    alignItems: alignItems,
    justifyContent: justifyContent
  }, !!iconLeft && iconLeft, !!imageLeft && imageLeft, React.createElement(Box, {
    px: 2
  }, !!heading && React.cloneElement(heading, {
    fontSize: heading.props.fontSize || fontSize
  }), !!text && React.cloneElement(text, {
    fontSize
  }), URLProps && ctaText && React.createElement(CustomLink, {
    p: linkVariation === 'fill' || linkVariation === 'outline' ? 2 : null,
    color: linkColor,
    variation: linkVariation,
    fontSize: fontSize,
    ...URLProps
  }, React.cloneElement(ctaText, {
    fontSize,
    zIndex: 2
  })), buttonClick && typeof buttonClick === 'function' && ctaText && React.createElement(CustomButton, {
    size: buttonSize,
    buttonTextUnderline: buttonVariation === 'link',
    variation: buttonVariation,
    onClick: onClick
  }, React.cloneElement(ctaText, {
    fontSize
  }))), !!iconRight && iconRight)));
}